class expressAddressAvailabilityController {
    constructor($window, moveFocus, settings) {
        this.$window = $window;
        this.moveFocus = moveFocus;
        this.settings = settings;
    }

    get isExpressAvailable() {
        return this.isValidated && this.isExpress && !this.isDeliveryWindowClosed;
    }

    mapFulfilmentStoreDetails(response) {
        this.isValidated = false;
        this.isExpress = false;
        this.isDeliveryWindowClosed = false;

        if (response && response.IsExpress != null) {
            this.isValidated = true;
            this.isExpress = response.IsExpress;
            this.isDeliveryWindowClosed = response.IsDeliveryWindowClosed;

            if (response.IsExpress && !response.IsDeliveryWindowClosed) {
                this.storeName = response.StoreName;
                this.bannerMessage = this.settings.expressLandingPage.expressAvailabilityMessage;
                this.dayCode = response.DayCode;
                this.timeLimit = response.TimeLimit;
                this.amPmValue = response.AmPmValue;
                this.moveFocus('#statusMessageBannerAvailable');
            } else {
                this.moveFocus('#statusMessageBannerUnavailable');
                this.bannerMessage = (response.IsDeliveryWindowClosed) ? this.settings.expressLandingPage.expressWindowClosedMessage : this.settings.expressLandingPage.expressNonAvailabilityMessage;
            }
        }

        // MoveFocus “works” but the banner is in the way essentially
        this.$window.scrollTo(0, 0);
    }
}

const expressAddressAvailabilityControllerComponentDefinition = {
    controller: ['$window', 'MoveFocus', 'Settings', expressAddressAvailabilityController],
    template: require('./express-address-availability.component.html').trim(),
};

module.exports = {
    expressAddressAvailabilityController,
    expressAddressAvailabilityControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/express/express-address-availability.component.js